<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <div class="page-title">
    <i class="fa-solid fa-container-storage"></i>
    <span class="space-icon"></span>
    {{ container.container_code }}
    <span
      :class="[
        'px-2 py-1 text-xs font-medium rounded-full text-white',
        container.org_invoices_paid ? 'bg-green-500' : 'bg-red-500',
      ]"
    >
      {{ container.org_invoices_paid ? "Pagado" : "No pagado" }}
    </span>
  </div>
  <div class="panel">
    <div class="panel-body">
      <div class="divide-gray-200">
        <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-6">
          <div class="sm:col-span-2">
            <dt class="label-data">
              {{ $t("model.container.week") }}
            </dt>
            <dd class="content-data">
              {{ container.week }}
            </dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="label-data">{{ $t("model.container.customer") }}:</dt>
            <dd class="content-data">{{ container.customer?.name }}</dd>
          </div>
          <div class="sm:col-span-2">
            <dt class="label-data">
              {{ $t("model.container.exporter_process_brand") }}:
            </dt>
            <dd class="content-data">
              {{ container?.brand_name }}
            </dd>
          </div>
          <div
            class="sm:col-span-2"
            v-if="
              container.provider_producer || container.provider_organization
            "
          >
            <dt class="label-data">{{ $t("model.container.provider") }}:</dt>
            <dd class="content-data">
              {{ provider_label }}
            </dd>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AEFinancesContainerIncomesContainerInfo",
  props: {
    container: {
      type: Object,
      required: true,
    },
  },
  computed: {
    provider_label: function () {
      if (
        this.container.provider_organization &&
        this.container.provider_producer
      ) {
        return `${this.container.provider_organization.name} - ${this.container.provider_producer.fullname}`;
      } else if (this.container.provider_organization)
        return this.container.provider_organization.name;
      else if (this.container.provider_producer)
        return this.container.provider_producer.fullname;
      else return "";
    },
  },
};
</script>
